  import logoTT from '../../assets/imageTelecom.svg'
import logoOoredooNew from '../../assets/imageOoredooRecharge.svg'
import LogoFreeSEN from '../../assets/freeSen.svg'
import Lyca from '../../assets/operateurRecharge/Lycamobile.svg'
import ttMarocLogo from '../../assets/telecomMaroc.svg'
import inwiLogo from '../../assets/inwiMaroc.svg'
import PosteFR from '../../assets/operateurRecharge/LaPosteMobile.svg'
import FreeFR from '../../assets/operateurRecharge/FreeMobileFR.svg'

import {Telefonica, TelekomDE, TimIT, Vodafone, Windtre, Orange, TelenetBase, KPN, 
  TMobileNL, PostLux, Cosmote, Nova, MEO, NOS, Movistar,
  mobilisAlg, Djezzi, ExpressoSen,
  jazz,
  Zong,
  Telenor,
  Turkcell,
  TurkTelekom,
  Grameenphone,
  Robi,
  Banglalik,Proximus,TelecelMali,MoovAfricaMali,
  MNTNig,
  AirtelNig,
  GlobalCom,
  TelkomKen,
  SafarieCom,
  SwissCon,
  Salt,
  Sunrise,
  O2UK,
  ThreeUK,
  MobileCH,
  TelecomCH,
  UnicomCH,
  Viettel,
  VNPT,
  MobiFone,
  DIGI,
  Joi,
  VodafoneIdea
} from '../../assets/operateurRecharge/index'

import {
  logoModalTT, logoModalOrange, logoModalOoredoo, 
  logoModalFree, logoModalInwi, logoModalExpresso, 
  logoModalMobilis, logoModalDjezzy, logoModalTTMaroc, LogoModalLyca, 
  logoModalPosteFR, logoModalFreeFR, logoModalVodafone,
   logoModalWindtre, logoModalTim, logoModalTelefonica,
  logoModalTelekomDE, logoModalTelenetbase,logoModalKPN,
  logoModaPosteLux, logoModalCosmote, logoModalNova,
  logoModalMEO, logoModalNOS, LogoModalMovistar,
  LogoModalJazz, LogoModalZong, LogoModalTelenor,
  LogoModalTukCell, LogoModalTurkTeleKom, LogoModalGreenPhone,
  LogoModalBanglalik, LogoModalRobi, LogoModalProximus,
  LogoModalAirtel,
  LogoModalTelkomKE,
  LogoModalSafarieKE,
  logoModalUnicomCH,
  LogoModalMobileCH,
  logoModalTelecomCH} from '../../assets/index'
  
  export const PROVIDERCONFIG: Record<string, {
    logo: string, icon: string, width: string, prefix?:string, value:string, styleText?:string
  }> = {
  TWTN: {
    prefix:'+216',
    value: 'Tunisie Télécom',
    logo: logoTT,
    icon: logoModalTT,
    width: 'w-[59px] h-auto',
  },
  ORTN: {
    prefix:'+216',
    value: 'Orange Tunisie',
    logo: Orange,
    icon: logoModalOrange,
    width: 'w-[33px] h-auto',
  },
  ORMA: {
    prefix:'+212',
    value: 'Orange Maroc',
    logo: Orange,
    icon: logoModalOrange,
    width: 'w-[33px] h-auto',
  },
  ORSN: {
    prefix:'+221',
        value: 'Orange Sénégal',
    logo: Orange,
    icon: logoModalOrange,
    width: 'w-[33px] h-auto',
  },
 
  TUTN: {
    prefix:'+216',
      value: 'Ooredoo Tunisie',
    logo: logoOoredooNew,
    icon: logoModalOoredoo,
    width: 'w-[102px] h-auto',
  },
  INMA: {
    prefix:'+212',
        value: 'Inwi',
    logo: inwiLogo,
    icon: logoModalInwi,
    width: 'w-[97px] h-auto',
  },
  MOMA: {
    prefix:'+212',
    value: 'Maroc Telecom',
    logo: ttMarocLogo,
    icon: logoModalTTMaroc,
    width: 'w-[67px] h-auto',
  },
  DJDZ: {
    prefix:'+213',
        value: 'Djezzi',
    logo: Djezzi,
    icon: logoModalDjezzy,
    width: 'w-[35px] h-auto',
  },
  MDDZ: {
    prefix:'+213',
        value: 'Mobilis',
    logo: mobilisAlg,
    icon: logoModalMobilis,
    width: 'w-[80px] h-auto',
  },
  OODZ: {
    prefix:'+213',
        value: 'Ooredoo Algérie',
    logo: logoOoredooNew,
    icon: logoModalOoredoo,
    width: 'w-[100px] h-auto',
  },
  TISN: {
    prefix:'+221',
        value: 'Free',
    logo: LogoFreeSEN,
    icon: logoModalFree,
    width: 'w-[80px] h-auto',
  },
  XPSN: {
    prefix:'+221',
        value: 'Expresso',
    logo: ExpressoSen,
    icon: logoModalExpresso,
    width: 'w-[78px] h-auto',
  },

  LYFR: {
    prefix:'+33',
    value: 'Lyca Mobile',
    logo: Lyca,
    icon: LogoModalLyca,
    width: 'w-[78px] h-auto',
  },
   ORFR: {
    prefix:'+33',
        value: 'Orange',
    logo: Orange,
    icon: logoModalOrange,
    width: 'w-[33px] h-auto',
  },
  LPFR: {
    prefix:'+33',
        value: 'La Poste Mobile',
    logo: PosteFR,
    icon: logoModalPosteFR,
    width: 'w-[60px] h-auto',
  },
  '1E3143FR': {
    prefix:'+33',
        value: 'Free Mobile',
    logo: FreeFR,
    icon: logoModalFreeFR,
    width: 'w-[80px] h-auto',
  },

   IMIT: {
    prefix:'+39',
        value: 'TIM',
    logo: TimIT,
    icon: logoModalTim,
    width: 'w-[60px] h-auto',
  },
   VFIT: {
    prefix:'+39',
        value: 'Vodafone',
    logo: Vodafone,
    icon: logoModalVodafone,
    width: 'w-[102px] h-auto',
  },
   WIIT: {
    prefix:'+39',
        value: 'Wind Tre',
    logo: Windtre,
    icon: logoModalWindtre,
    width: 'w-[60px] h-auto',
  },
  TLDE: {
    prefix:'+49',
          value: 'Deutsche Telekom',
    logo: TelekomDE,
    icon: logoModalTelekomDE,
    width: 'w-[100px] h-auto',
  },
  VFDE: {
    prefix:'+49',
          value: 'Vodafone',

    logo: Vodafone,
    icon: logoModalVodafone,
    width: 'w-[100px] h-auto',
  },
  O2DE: {
    prefix:'+49',
          value: '(O2) Telefónica',
    logo: Telefonica,
    icon: logoModalTelefonica,
    width: 'w-[100px] h-auto',
  },

  PXBE: {
    prefix:'+32',
          value: 'Proximus',
    logo: Proximus,
    icon: LogoModalProximus,
    width: 'w-[100px] h-auto',
  },
  ORBE: {
    prefix:'+32',
          value: 'Orange',
    logo: Orange,
    icon: logoModalOrange,
    width: 'w-[33px] h-auto',
  },
  B5BE: {
    prefix:'+32',
          value: 'BASE',

    logo: TelenetBase,
    icon: logoModalTelenetbase,
    width: 'w-[100px] h-auto',
  },

   '0KNL': {
    prefix:'+31',
        value: 'KPN',
    logo: KPN,
    icon: logoModalKPN,
    width: 'w-[100px] h-auto',
  },
   VFNL: {
    prefix:'+31',
        value: 'Vodafone',
    logo: Vodafone,
    icon: logoModalVodafone,
    width: 'w-[100px] h-auto',
  },
   TLNL: {
    prefix:'+31',
        value: 'T- Mobile',
    logo: TMobileNL,
    icon: logoModalTelekomDE,
    width: 'w-[100px] h-auto',
  },

  '0LLU': {
    prefix:'+352',
        value: 'POST Luxembourg ',
    logo: PostLux,
    icon: logoModaPosteLux,
    width: 'w-[45px] h-auto',
  },
  ORLU: {
    prefix:'+352',
        value: 'Orange',
    logo: Orange,
    icon: logoModalOrange,
    width: 'w-[33px] h-auto',
  },
  
  CFGR: {
    prefix:'+30',
        value: 'Cosmote',
    logo: Cosmote,
    icon: logoModalCosmote,
    width: 'w-[100px] h-auto',
  },
  VFGR: {
    prefix:'+30',
        value: 'Vodafone',
    logo: Vodafone,
    icon: logoModalVodafone,
    width: 'w-[100px] h-auto',
  },
  WIGR: {
    prefix:'+30',
        value: 'Nova',
    logo: Nova,
    icon: logoModalNova,
    width: 'w-[100px] h-auto',
  },

  MUPT: {
    prefix:'+351',
     value: 'MEO',
    logo: MEO,
    icon: logoModalMEO,
    width: 'w-[60px] h-auto',
  },
  NOPT: {
    prefix:'+351',
    value: 'NOS',
    logo: NOS,
    icon: logoModalNOS,
    width: 'w-[60px] h-auto',
  },
  VFPT: {
    prefix:'+351',
    value: 'Vodafone',
    logo: Vodafone,
    icon: logoModalVodafone,
    width: 'w-[100px] h-auto',
  },

  TFES: {
    prefix:'+34',
          value: 'Movistar',
    logo: Movistar,
    icon: LogoModalMovistar,
    width: 'w-[100px] h-auto',
  },
  VFES: {
    prefix:'+34',
          value: 'Vodafone',
    logo: Vodafone,
    icon: logoModalVodafone,
    width: 'w-[100px] h-auto',
  },
  ORES: {
    prefix:'+34',
          value: 'Orange',
    logo: Orange,
    icon: logoModalOrange,
    width: 'w-[33px] h-auto',
  },


   MBPK: {
    prefix:'+92',
          value: 'Jazz',
    logo: jazz,
    icon: LogoModalJazz,
    width: 'w-[45px] h-auto',
  },
  ZNPK: {
    prefix:'+92',
          value: 'Zong',

      logo: Zong,
      icon: LogoModalZong,
      width: 'w-[100px] h-auto',
    },
    TPPK: {
      prefix:'+92',
          value: 'Telenor',
      logo: Telenor,
      icon: LogoModalTelenor,
      width: 'w-[100px] h-auto',
    },

    TZTR: {
      prefix:'+90',
          value: 'Turkcell',
      logo: Turkcell,
      icon: LogoModalTukCell,
      width: 'w-[100px] h-auto',
    },
    VFTR: {
      prefix:'+90',
          value: 'Vodafone',
      logo: Vodafone,
      icon: logoModalVodafone,
      width: 'w-[100px] h-auto',
    },

    AVTR: {
      prefix:'+90',
          value: 'Turk Telekom',
      logo: TurkTelekom,
      icon: LogoModalTurkTeleKom,
      width: 'w-[100px] h-auto',
    },

    GEBD: {
      prefix:'+880',
          value: 'Grameenphone',
      logo: Grameenphone,
      icon: LogoModalGreenPhone,
      width: 'w-[100px] h-auto',
    },
    BGBD: {
      prefix:'+880',
          value: 'Banglalink',
      logo: Banglalik,
      icon: LogoModalBanglalik,
      width: 'w-[100px] h-auto',
    },
    RLBD: {
      prefix:'+880',
          value: 'Robi',
      logo: Robi,
      icon: LogoModalRobi,
      width: 'w-[70px] h-auto',
    },
    //mali
    ORML: {
      prefix:'+223',
      value: 'Orange',
      logo: Orange,
      icon: logoModalOrange,
      styleText:'text-[32px]',
      width: 'w-[33px] h-auto',
    },
    LTML: {
      prefix:'+223',
      value: 'Telecel',
      logo: TelecelMali,
      icon: logoModalOrange,
      styleText:'text-[32px]',
      width: 'w-[46px] h-auto',
    },

    XMML: {
      prefix:'+223',
      value: 'Moov Africa Mali',
      logo: MoovAfricaMali,
      icon: MoovAfricaMali,
      styleText:'text-[32px]',
      width: 'w-[56px] h-auto',
    },
    
    //Nigeria
    MTNG: {
      prefix:'+234',
      value: 'MTN Nigeria',
      logo: MNTNig,
      icon: MNTNig,
      width: 'w-[56px] h-auto',
      styleText:'text-[28px]'
    },
    ZANG: {
      prefix:'+234',
      value: 'Airtel Nigeria',
      logo: AirtelNig,
      icon: LogoModalAirtel,
      width: 'w-[90px] h-auto',
      styleText:'text-[28px]'
    },
    GLNG: {
      prefix:'+234',
      value: 'Globacom (Glo) Nigeria',
      logo: GlobalCom,
      icon: GlobalCom,
      width: 'w-[55px] h-auto',
      styleText:'text-[28px]'
    },

    //Kenya
    SAKE: {
      prefix:'+254',
      value: 'Safaricom Kenya',
      logo: SafarieCom,
      icon: LogoModalSafarieKE,
      width: 'w-[90px] h-auto',
      styleText:'text-[30px]'
    },
    AIKE: {
      prefix:'+254',
      value: 'Airtel Kenya',
      logo: AirtelNig,
      icon: LogoModalAirtel,
      width: 'w-[90px] h-auto',
      styleText:'text-[30px]'
    },
    KTKE: {
      prefix:'+254',
      value: 'Telkom Kenya',
      logo: TelkomKen,
      icon: LogoModalTelkomKE,
      width: 'w-[90px] h-auto',
      styleText:'text-[30px]'
    },

    //Switzerland (suisse)
    KXCH: {
      prefix:'+41',
      value: 'Swisscom Suisse',
      logo: SwissCon,
      icon: LogoModalTelkomKE,
      width: 'w-[60px] h-auto',
    },
    KWCH: {
      prefix:'+41',
      value: 'Sunrise Suisse ',
      logo: Sunrise,
      icon: LogoModalTelkomKE,
      width: 'w-[50px] h-auto',
      styleText:'text-[30px]'
    },
    W3CH: {
      prefix:'+41',
      value: 'Salt Suisse',
      logo: Salt,
      icon: LogoModalTelkomKE,
      width: 'w-[60px] h-auto',
      styleText:'text-[30px]'
    },

// UK United Kingdom
    VFGB: {
      prefix:'+44',
      value: 'Vodafone UK',
      logo: Vodafone,
      icon: logoModalVodafone,
      width: 'w-[110px] h-auto',
    },
    O2GB: {
      prefix:'+44',
      value: 'O2 UK',
      logo: O2UK,
      icon: O2UK,
      width: 'w-[50px] h-auto',
    },
    HTGB: {
      prefix:'+44',
      value: 'Three (3 UK) ',
      logo: ThreeUK,
      icon: ThreeUK,
      width: 'w-[35px] h-auto',
    },

    //China
    C2CN: {
      prefix:'+86',
      value: 'China Mobile ',
      logo: MobileCH,
      icon: LogoModalMobileCH,
      styleText:'text-[35px]',
      width: 'w-[90px] h-auto',
    },
    C1CN: {
      prefix:'+86',
      value: 'China Telecom ',
      logo: TelecomCH,
      icon: logoModalTelecomCH,
      styleText:'text-[35px]',
      width: 'w-[90px] h-auto',
    },
    UMCN: {
      prefix:'+86',
      value: 'China Unicom ',
      logo: UnicomCH,
      icon: logoModalUnicomCH,
      styleText:'text-[35px]',
      width: 'w-[100px] h-auto',
    },


    //Vietnam
    VTVN: {
      prefix:'+84',
      value: 'Viettel',
      logo: Viettel,
      icon: Viettel,
      styleText:'text-[35px]',
      width: 'w-[75px] h-auto',
    },
    VNVN: {
      prefix:'+84',
      value: 'Vinaphone (VNPT)',
      logo: VNPT,
      icon: VNPT,
      styleText:'text-[35px]',
      width: 'w-[70px] h-auto',
    },
    MBVN: {
      prefix:'+84',
      value: 'MobiFone',
      logo: MobiFone,
      icon: MobiFone,
      styleText:'text-[35px]',
      width: 'w-[70px] h-auto',
    },


  //Roumanie
    ORRO: {
      prefix:'+40',
      value: 'Orange Roumanie',
      logo: Orange,
      icon: logoModalOrange,
      styleText:'text-[35px]',
      width: 'w-[35px] h-auto',
    },
     VFRO: {
      prefix:'+40',
      value: 'Vodafone Roumanie',
      logo: Vodafone,
      icon: logoModalVodafone,
      styleText:'text-[35px]',
      width: 'w-[75px] h-auto',
    },
     DIGI_RO: {
      prefix:'+40',
      value: 'Digi Mobil',
      logo: DIGI,
      icon: DIGI,
      styleText:'text-[35px]',
      width: 'w-[50px] h-auto',
    },

    //Inde
    JIOIN: {
      prefix:'+91',
      value: 'Joi',
      logo: Joi,
      icon: Joi,
      styleText:'text-[35px]',
      width: 'w-[35px] h-auto',
    },
    AIRTELIN: {
      prefix:'+91',
      value: 'Airtel',
      logo: AirtelNig,
      icon: LogoModalAirtel,
      styleText:'text-[35px]',
      width: 'w-[65px] h-auto',
    },
    VIN: {
      prefix:'+91',
      value: 'Vi (Vodafone Idea)',
      logo: VodafoneIdea,
      icon:  VodafoneIdea,
      styleText:'text-[35px]',
      width: 'w-[50px] h-auto',
    },
   
}